import src from "IMAGE";
export default { src, width: 134, height: 64, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATElEQVR42nWNOwoAMQhErTZufgtJiGgneP8zrnZpMvCmGt4AEXVm/tZa9UREmpl1KKU8cMmcE6PSbYCICVQ1uw5dG7xOjou9dxtj1B+ObAXVYHVzKgAAAABJRU5ErkJggg==", blurWidth: 8, blurHeight: 4 }
